module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/gb-nir-f9fcc604971f0e53b88d3edf29000e85.svg";